import { EventEmitter} from 'events';
import {debounce} from 'underscore';
let _view;
let _emitter=new EventEmitter();
let _error;
let HOST="http://192.168.1.15:4000";
//events
const onChange = debounce(() => {
    _emitter.emit('change');
}, 10);
const on = (event, handler) => {
    _emitter.on(event, handler);
}

const off = (event, handler) => {
    _emitter.removeListener(event, handler);
}
//setters
const setError = (error) => {
    _error = error;
    onChange();
}
const setView=(view)=>{
    _view=view;
    //console.log("setView");
    onChange();
}
//getters
const getView=()=>{
    return _view;
}
const getError=()=>{
    return _error;
}
// requests
const fetchTableUser= async ()=>{
    //console.log("entro en fetchTableUser");
    let body={command:"userTable"};
    let result=[];
    let response=await fetch(HOST+'/db/get', {
            method: 'post',
            body: JSON.stringify(body),
            headers: {'Content-Type': 'application/json'}
        }).catch(()=>{console.log("error gorderas")});
    //console.log("esta es la respuesta: ",response);
    if (response && response.ok){
        result = await response.json();
        console.log("este es el resultado: ",result);
        
    }
    //onChange();
    return result
}
const fetchTableFeatures = async ()=>{
    //console.log("entro en fetchTableUser");
    let body={command:"features"};
    let result;
    let response=await fetch(HOST+'/db/get', {
            method: 'post',
            body: JSON.stringify(body),
            headers: {'Content-Type': 'application/json'}
        }).catch(()=>{console.log("error gorderas")});
    //console.log("esta es la respuesta: ",response);
    if (response && response.ok){
        result = await response.json();
        console.log("este es el resultado: ",result);
        
    }
    //onChange();
    return result
}
const fetchUserInfo = async (user)=>{
    let body={command:"userInfo",data:user};
    console.log("body userInfo", body);
    let result;
    let response=await fetch(HOST+'/db/get', {
            method: 'post',
            body: JSON.stringify(body),
            headers: {'Content-Type': 'application/json'}
        }).catch((e)=>{console.log("error gorderas en get UserInfo ",e)});
    //console.log("esta es la respuesta: ",response);
    if (response && response.ok){
        result = await response.json();
        console.log("este es el resultado en userInfo: ",result);
        
    }
    //onChange();
    return result
}
const insertNewUser= async (userData)=>{
    let body={command:"insertUser",data:userData};
    let result;
    let response=await fetch(HOST+'/db/set', {
            method: 'post',
            body: JSON.stringify(body),
            headers: {'Content-Type': 'application/json'}
        }).catch((e)=>{console.log("error gorderas en new user ",e)});
    //console.log("esta es la respuesta: ",response);
    if (response && response.ok){
        result = await response.json();
        console.log("este es el resultado en new user: ",result);
        
    }
    //onChange();
    return result
}
const insertNewFeature= async (feature)=>{
    let body={command:"insertFeature",data:feature};
    let result;
    let response=await fetch(HOST+'/db/set', {
            method: 'post',
            body: JSON.stringify(body),
            headers: {'Content-Type': 'application/json'}
        }).catch((e)=>{console.log("error gorderas en new Feature ",e)});
    //console.log("esta es la respuesta: ",response);
    if (response && response.ok){
        result = await response.json();
        console.log("este es el resultado en new feature: ",result);
        
    }
    //onChange();
    return result
}
const deleteUser = async (userData)=>{
    let body={command:"deleteUser",data:userData};
    let result;
    let response=await fetch(HOST+'/db/set',{
        method:'post',
        body:JSON.stringify(body),
        headers:{'Content-Type':'application/json'}
    }).catch((e)=>{console.log('error gorderas en delete user ',e)});
    if (response && response.ok){
        result=await response.json();
        console.log("este es el resultado del borrado del user: ",result);
    }
    return result;
}
const deleteFeature = async (feature)=>{
    let body={command:"deleteFeature",data:feature};
    let result;
    let response=await fetch(HOST+'/db/set',{
        method:'post',
        body:JSON.stringify(body),
        headers:{'Content-Type':'application/json'}
    }).catch((e)=>{console.log('error gorderas en delete feature ',e)});
    if (response && response.ok){
        result=await response.json();
        console.log("este es el resultado del borrado de la feature: ",result);
    }
    return result;
}
const deleteSlot = async (user)=>{
    let body={command:"liberateSlot",data:user};
    let result;
    let response=await fetch(HOST+'/db/set',{
        method:'post',
        body:JSON.stringify(body),
        headers:{'Content-Type':'application/json'}
    }).catch((e)=>{console.log('error gorderas en delete slot ',e)});
    if (response && response.ok){
        result=await response.json();
        console.log("este es el resultado del borrado del slot: ",result);
    }
    return result;
}
const updateUserData= async (userData)=>{
    let body={command:"updateUserInfo",data:userData};
    let result;
    let response=await fetch(HOST+'/db/set',{
        method:'post',
        body:JSON.stringify(body),
        headers:{'Content-Type':'application/json'}
    }).catch((e)=>{console.log('error gorderas en delete feature ',e)});
    if (response && response.ok){
        result=await response.json();
        if (result.status==="ok"){
            alert("Usuario Actualizado");
        }else{
            alert("Error: "+result.message);
        }
    }
    //alert(JSON.stringify(result));
    return result;
}
const director={
    //setters
    setError,
    setView,
    //getters
    getError,
    getView,
    //evnets
    on,
    off,
    //fuctions
    fetchTableUser,
    fetchTableFeatures,
    fetchUserInfo,
    insertNewUser,
    insertNewFeature,
    deleteUser,
    deleteFeature,
    deleteSlot,
    updateUserData
}
export default director;